import { render, staticRenderFns } from "./CadastrarUsuario.vue?vue&type=template&id=2676f393&"
import script from "./CadastrarUsuario.vue?vue&type=script&lang=js&"
export * from "./CadastrarUsuario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports